/**
 * 观看限制 - 免费
 * Create by liaokai on 2020-06-11 16:47:10
 */
import * as React from 'react';
import {Component} from "react";

interface IProps{
    data? : IState
    onChange? : (data: IState) => void
}

interface IState{
    type : number   //1免费 2 收费 3 邀请码 4 密码 5 白名单
}

export class LiveLimitFree extends Component<IProps,IState>{
    readonly state : IState = this.props?.data ?? {
        type : 1
    };

    componentDidMount() {
        this.props.onChange?.(this.state)
    }

    render() {
        let {} = this.props;
        let {} = this.state;
        return (
            <div>
                观看无需任何验证，即可观看直播
            </div>
        );
    }
}
